<div class="d-flex gap-2 gap-sm-4">
  <div class="placeholder-glow flex-grow-1 flex-lg-grow-0 col-lg-5">
    <span class="placeholder px-3 rounded-2 py-3 w-100 text_2 overflow-hidden border border-2">Loading</span>
  </div>

  <div class="placeholder-glow px-2 d-none d-lg-block">
    <span class="placeholder px-5 rounded-2 py-3 text_2 overflow-hidden border border-2">Loading</span>
  </div>

  <div class="placeholder-glow d-none d-lg-block">
    <span class="placeholder px-4 rounded-2 py-3 w-100 text_2 overflow-hidden border border-2">Loading</span>
  </div>

  <div class="placeholder-glow">
    <span class="placeholder px-lg-4 rounded-2 py-3 w-100 text_2 overflow-hidden border border-2">Loading</span>
  </div>
</div>
